import {Opening} from "../../../../../../api/Openings";
import {UnitSystem} from "../../../../../../api/Projects";
import {inches} from "../../const";
import {parseDrawingUnits} from "../../util/DrawingUnits";
import {MdFrameStick} from "./MdFrameBlock";

// the tallest opening the auto anchor qty covers (dimensionformula.MaxAutoQtyHeight).
const MAX_AUTO_QTY_HEIGHT = 132 * inches;

// the anchors per side of a frame, as dimensionformula.GetHingeCountForOneSide2 counts them. Null
// when the height is over the auto range.
function anchorsPerSide(nominalHeight: number): number | null {
    if(nominalHeight <= 60 * inches) return 2;
    if(nominalHeight <= 90 * inches) return 3;
    if(nominalHeight <= 120 * inches) return 4;
    if(nominalHeight <= MAX_AUTO_QTY_HEIGHT) return 5;
    return null;
}

// put the opening's anchors on the two side jambs of a new frame: one section each, the total from
// dimensionformula.GetFrameAnchorCount (the qty override, else the per-side count x 2). An odd total
// gives the left jamb the extra one. Over the auto height with no override, no anchors.
export function seedDefaultJambAnchors(left: MdFrameStick, right: MdFrameStick, opening: Opening, sys: UnitSystem, product: number) {
    let total: number;
    if(opening.frameAnchorQtyOverride != null) {
        total = opening.frameAnchorQtyOverride;
    } else {
        const perSide = anchorsPerSide(parseDrawingUnits(opening.nominalHeight, sys));
        if(perSide === null) return;
        total = perSide * 2;
    }

    const leftQty = Math.ceil(total / 2);
    const rightQty = total - leftQty;

    if(leftQty > 0) left.anchors = {sections: [{length: 1, product, qty: leftQty}]};
    if(rightQty > 0) right.anchors = {sections: [{length: 1, product, qty: rightQty}]};
}
